import ReceiptIcon from '@mui/icons-material/Receipt';

import OrderList from './OrderList';

export default {
  list: OrderList,
  icon: ReceiptIcon,
  recordRepresentation: (record: any) => ` ${record.id}`,
};
